export default {
  getTip: (state) => state.tip,
};
